import { getTranslateByKey } from "@/main/services/utils";

import Card from "./card";
import * as S from "./styles";
import { CardProps } from "@mui/material";
import { useUserReducer } from "@/main/store/user";

const addIconSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="4rem"
		height="4rem"
		viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet"
	>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#CDDAE6" stroke="none">
			<path
				d="M2421 5105 c-178 -39 -348 -172 -429 -336 -72 -146 -72 -140 -72
          -896 l0 -673 -672 0 c-757 0 -751 0 -897 -72 -210 -103 -351 -332 -351 -568 0
          -236 141 -465 351 -568 146 -72 140 -72 897 -72 l672 0 0 -672 c0 -757 0 -751
          72 -897 103 -210 332 -351 568 -351 236 0 465 141 568 351 72 146 72 140 72
          897 l0 672 673 0 c756 0 750 0 896 72 210 103 351 332 351 568 0 236 -141 465
          -351 568 -146 72 -140 72 -896 72 l-673 0 0 673 c0 756 0 750 -72 896 -126
          256 -423 397 -707 336z"
			/>
		</g>
	</svg>
);

interface ICardShoppingProps extends CardProps {}

export function FindMoreSuppliers({ ...props }: ICardShoppingProps) {
	const userReducer = useUserReducer();

	return (
		<Card
			className={`${(!userReducer.userPreference.preferences.isViewCard && "box-layout-card-collumn") || ""}`}
			maxWidth={userReducer.userPreference.preferences.isViewCard ? "400px" : "100%"}
			{...props}
		>
			<S.ContentFindMoreSuppliers
				id="id-createOrder-findMoreSuppliers"
				active={userReducer.userPreference.preferences.isViewCard}
			>
				{addIconSvg()}
				<S.AreaTitleCardShopping>
					<S.TitleCardShopping>{getTranslateByKey("information.findMoreSuppliers")}</S.TitleCardShopping>
				</S.AreaTitleCardShopping>
			</S.ContentFindMoreSuppliers>
		</Card>
	);
}
